"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { House, LayoutList, Wrench, CircleCheck } from "lucide-react";
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const steps = [{
    number: 1,
    title: "Consultation Initiale",
    description: "Nous analysons vos besoins spécifiques et l'architecture de votre espace pour définir les objectifs de votre projet de rénovation durable. Une première étape clé pour garantir une harmonie parfaite entre esthétique et fonctionnalité.",
    icon: House
  }, {
    number: 2,
    title: "Conception & Devis",
    description: "Nos experts élaborent un plan détaillé incluant le choix des matériaux éco-responsables et un calendrier précis. Vous recevez une proposition transparente, sans frais cachés, alignée sur votre budget et vos aspirations.",
    icon: LayoutList
  }, {
    number: 3,
    title: "Mise en Œuvre",
    description: "Nos artisans qualifiés réalisent les travaux avec une rigueur absolue. Nous assurons une gestion propre du chantier, le respect des normes environnementales et une communication constante sur l'avancement des étapes techniques.",
    icon: Wrench
  }, {
    number: 4,
    title: "Livraison & Garantie",
    description: "Après une série de tests de qualité rigoureux, nous vous remettons les clés de votre nouvel espace. Vous bénéficiez d'un suivi post-chantier et de notre garantie décennale pour une sérénité totale sur le long terme.",
    icon: CircleCheck
  }];
  return <section data-section-id="262553" id="how-it-works" className="w-full bg-background text-foreground py-16 md:py-24 lg:py-32" ref={ref}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="mb-12 md:mb-16 lg:mb-20 text-center">
          <p className="text-sm font-semibold text-primary tracking-widest uppercase mb-3">
            NOTRE PROCESSUS
          </p>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight">
            Votre projet en 4 étapes
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => {
          const IconComponent = step.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full border border-border bg-card hover:shadow-xl transition-all duration-300 flex flex-col rounded-lg">
                  {}
                  <div className="px-6 pt-6">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-secondary rounded-lg text-secondary-foreground shadow-sm">
                      <IconComponent size={24} strokeWidth={2} />
                    </div>
                  </div>

                  {}
                  <CardHeader className="px-6 py-4">
                    <div className="flex items-start gap-3 mb-2">
                      <span className="text-sm font-bold text-primary/60 font-mono">
                        0{step.number}
                      </span>
                      <CardTitle className="font-default text-xl font-bold text-foreground">
                        {step.title}
                      </CardTitle>
                    </div>
                  </CardHeader>

                  {}
                  <CardContent className="px-6 pb-6 flex-1">
                    <p className="text-base leading-relaxed text-muted-foreground font-default">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}